import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/coach/unauthenticated")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="flex flex-col gap-4">
          <h1 className="text-2xl font-bold">Unauthorized</h1>
          <p className="text-sm text-gray-500">
            You are not authorized to access this page.
          </p>
        </div>
      </div>
    </div>
  );
}
